import React, { Suspense } from 'react';
import ReduxContainer from '@/ReduxContainer';
import DirectQuote from './DirectQuote';

const DirectQuoteContainer = ({ source, setMenuId, disableInertia }) => (
    <ReduxContainer>
        <Suspense fallback={<></>}>
            <DirectQuote
                source={source}
                setMenuId={setMenuId}
                disableInertia={disableInertia}
            />
        </Suspense>
    </ReduxContainer>
);

export default DirectQuoteContainer;
